import { Injectable } from '@angular/core';
import { LeapApiService, PersonSyncStatus } from './leap-api.service';
import {
	AddLawyerClerkToLeapMatterErrorReason,
	AddLawyerClerkToLeapMatterUnsuccessfulComponent,
} from './modals/add-lawyer-clerk-to-leap-matter-unsuccessful/add-lawyer-clerk-to-leap-matter-unsuccessful.component';
import { BusinessUser } from '@models/businesses';
import { MatDialog } from '@angular/material/dialog';
import { catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { SnackbarService } from '@services/ui/snackbar.service';
import { ICON } from '@core/util/icon';
import LogRocket from 'logrocket';

@Injectable({
	providedIn: 'root',
})
export class LeapLawyerClerkService {
	constructor(
		private leapApiService: LeapApiService,
		private dialog: MatDialog,
		private snackbarService: SnackbarService,
	) {}

	syncMatterUser(
		matterId: string,
		user: BusinessUser,
		isLawyer: boolean,
		addingMortgages: boolean = false,
	): void {
		const userType = isLawyer ? 'lawyer' : 'clerk';

		this.leapApiService
			.syncMatterUser(matterId, user.id, isLawyer, addingMortgages)
			.pipe(
				take(1),
				catchError((err) => {
					console.error(err);
					LogRocket.error(`Unable to sync ${userType} to Leap.`, {
						error: err,
					});
					this.snackbarService.openSnackBar({
						text: `An error occurred while trying to sync ${userType} to Leap.`,
						type: 'error',
						icon: ICON.ERROR,
					});
					return of({ closerName: '', leapName: '', personSyncState: null });
				}),
			)
			.subscribe((result) => {
				switch (result.personSyncState) {
					case PersonSyncStatus.UserNotInLeap:
						this.dialog.open(AddLawyerClerkToLeapMatterUnsuccessfulComponent, {
							data: {
								closerLawyerOrClerkName: `${user.firstName} ${user.lastName}`,
								errorReason: isLawyer
									? AddLawyerClerkToLeapMatterErrorReason.LAWYER_NOT_EXIST_IN_LEAP
									: AddLawyerClerkToLeapMatterErrorReason.CLERK_NOT_EXIST_IN_LEAP,
							},
						});
						break;
					case PersonSyncStatus.UserNotOnboarded:
						this.dialog.open(AddLawyerClerkToLeapMatterUnsuccessfulComponent, {
							data: {
								closerLawyerOrClerkName: `${user.firstName} ${user.lastName}`,
								errorReason: isLawyer
									? AddLawyerClerkToLeapMatterErrorReason.LAWYER_NOT_ONBOARDED_IN_CLOSER
									: AddLawyerClerkToLeapMatterErrorReason.CLERK_NOT_ONBOARDED_IN_CLOSER,
							},
						});
						break;
					default:
						break;
				}
			});
	}
}
